<template>

  <modalo
    :title="source.name"
    type="mini"
    @hideModal="hideModal()"
    :modaloWatch="() => source">

    <form id="source-form" v-on:submit.prevent="saveSource(source)">
      <div class="form-group">
        <label>{{ $t('Name') }}</label>
        <input v-autofocus type="text" class="form-control" v-model="source.name">
        <ValidateMessage :error="validateErrors.name" />
      </div>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="source-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <button
          v-if="source._id"
          type="button"
          class="btn btn-danger"
          @click="deleteSource(source._id)">{{ $t('Delete') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
export default {
  name: 'SourceForm',
  components: {
  },
  props: [
    'initSource'
  ],
  data () {
    return {
      loading: false,
      source: this.defaultValues(this.initSource),
      validateErrors: {}
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveSource
    */
    saveSource (data) {
      if (data._id) this.updateSource(data)
      else this.createSource(data)
    },
    /*
    createSource
    */
    createSource (data) {
      this.loading = true

      this.$store
      .dispatch('createSource', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateSource
    */
    updateSource (data) {
      this.loading = true

      this.$store
      .dispatch('updateSource', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteSource (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteSource', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Source/SourceForm.vue